import React, {FC, memo} from "react";
import {TooltipForSectionProps} from './TooltipForSection-types';
import {Root, Text, Button, TooltipRoot, TooltipImage} from "./TooltipForSection-styles";
import IconHelp from "../Icons/IconHelp";

const TooltipForSection: FC<TooltipForSectionProps> = memo((props) => {
    const {uid, text, image} = props;

    return (
        <Root>
            <Text>
                <p>
                    {text}
                </p>
            </Text>

            <Button data-tip data-for={uid}>
                <IconHelp />
            </Button>

            {image &&
                <TooltipRoot id={uid} place="left" effect="float" arrowColor="transparent" backgroundColor="transparent">
                    <TooltipImage $src={image}/>
                </TooltipRoot>
            }
        </Root>
    )
});

export default TooltipForSection;
